import React from 'react';

interface NoDataSchoolIconProps {
  className?: string;
  size?: number;
}

const NoDataSchoolIcon: React.FC<NoDataSchoolIconProps> = ({ 
  className = "w-24 h-24 text-gray-300", 
  size = 24 
}) => {
  return (
    <div className={className}>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-full h-full"
      >
        <path d="M22 9l-10-4-10 4" />
        <path d="M20 9v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9" />
        <path d="M22 9l-10 4-10-4" />
        <path d="M12 13v6" />
        <path d="M8 17h8" />
      </svg>
    </div>
  );
};

export default NoDataSchoolIcon;
